import { selectApp } from './selectApp';

export const selectKaskoApplicationId = state => selectApp(state).kaskoApplicationId || '';
